import { translateCrmCodes } from './translateCrmCodes'

export const transformToCrmFormat = values => {
  const transformedData = {}

  for (const [key, value] of Object.entries(values)) {
    switch (key) {
      case 'birthDate':
        // results in format "03/26/1981"
        transformedData[key] = value
          ? value?.toLocaleDateString('en-US', {
              month: '2-digit',
              day: '2-digit',
              year: 'numeric'
            })
          : null
        break

      case 'salutation': {
        const reversedMapping = true

        transformedData[key] = value
          ? translateCrmCodes(key, value, reversedMapping)
          : null

        break
      }

      case 'title': {
        const reversedMapping = true

        transformedData[key] = value
          ? translateCrmCodes(key, value, reversedMapping)
          : null

        break
      }

      default:
        // keep other fields unchanged & transform empty string to null
        transformedData[key] = value === '' ? null : value
    }
  }

  return transformedData
}
